module.exports = __webpack_public_path__ + "img/medal.63fa8366.png";